/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./audit-overview-api/api";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const submitManualAdjustments = /* GraphQL */ `mutation SubmitManualAdjustments($adjustments: [ManualAdjustmentInput!]!) {
  submitManualAdjustments(adjustments: $adjustments) {
    message
    success
    timestamp
    __typename
  }
}
` as GeneratedMutation<
  APITypes.SubmitManualAdjustmentsMutationVariables,
  APITypes.SubmitManualAdjustmentsMutation
>;
